module.exports = __webpack_public_path__ + "static/img/app-thumb-desktop.b15867a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImg/app-thumb-desktop.png
// module id = T9qB
// module chunks = 0